import React from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { updateAvailableToStore } from './Store/commonStore/actions';
import { Store, persistor } from './Store/Store';
import reportWebVitals from './reportWebVitals';
import { msalConfig } from './authConfig';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
const msalInstance = new PublicClientApplication(msalConfig);

root.render(
    <Provider store={Store}>
        <PersistGate loading={null} persistor={persistor}>
            <React.Fragment>
                <BrowserRouter basename={process.env.PUBLIC_URL}>
                    <MsalProvider instance={msalInstance}>
                        <App />
                    </MsalProvider>
                </BrowserRouter>
            </React.Fragment>
        </PersistGate>
    </Provider>
);

serviceWorkerRegistration.register({
    onUpdate: (registration) => {
        updateAvailableToStore(true);
        if (registration && registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
    }
});

/*
 * If you want to start measuring performance in your app, pass a function
 * to log results (for example: reportWebVitals(console.log))
 * or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
 */

reportWebVitals();
